function check(ua) {
	if (!ua) {
		return;
	}

	var os = {}, browser = {};

	var oscheck = {
		iphone: ua.match(/(iphone)\s(os\s)?([\d_]+)/i),
		ipad: ua.match(/(ipad).*\s([\d_]+)/i),
		ipod: ua.match(/(ipod).*\s([\d_]+)/i),
		android: ua.match(/(android)\s([\d\.]+)/i),
		windows: ua.match(/Windows(\s+\w+)?\s+?(\d+\.\d+)/)
	};

	if (oscheck.ipod) {
		os.ios = os.ipod = true;
		os.version = oscheck.ipod[2].replace(/_/g, '.');
		os.name = 'ipod';
	}
	if (oscheck.ipad) {
		os.ios = os.ipad = true;
		os.version = oscheck.ipad[2].replace(/_/g, '.');
		os.name = 'ipad';
	}
	if (oscheck.iphone) {
		os.iphone = os.ios = true;
		os.version = oscheck.iphone[3].replace(/_/g, '.');
		os.name = 'iphone';
	}
	if (oscheck.android) {
		os.android = true;
		os.version = oscheck.android[2];
		os.name = 'android';
	}
	if (oscheck.windows) {
		os.windows = true;
		os.version = oscheck.windows[2];
		os.name = 'windows';
	}

	// 移动端APP的ua可能会有MQQBrowser、Chrome的关键字，为确保判断准确，关键字判断请尽量放在他们之前。
	var browsercheck = {
		IE: ua.match(/; msie\b|; trident\b|\bedge\//i),
		WeChat: ua.match(/MicroMessenger\/((\d+)\.(\d+))\.(\d+)/) || ua.match(/MicroMessenger\/((\d+)\.(\d+))/),
		MQQClient: (!ua.match(/QQReader/) && ua.match(/QQ\/(\d+\.\d+)/i) || ua.match(/V1_AND_SQ_([\d\.]+)/)),//QQ阅读伪装成了QQ然而不具备QQ的jsapi
		MQQReader: ua.match(/QQReader/i),
		sukan: ua.match(/synopsis/i),
		QQvideo: ua.match(/TADChid/i) ? false : ua.match(/QQLiveBrowser\/([\d.]+)/),//若发现广告ua,则不认为在app内。若先进入正常app的webview,再进入广告webview（广告webview是以添加参数方式修改ua）,会误判为还在app内，而使用app的jsapi
		QQADvideo: ua.match(/TADChid/i), // 广告ua
		QQHDvideo: ua.match(/QQLiveHDBrowser\/([\d.]+)/),
		TBSSDK: ua.match(/MQQBrowser\/(\d+\.\d+)/i) && ua.match(/MSDK\/(\d+\.\d+)/),
		MQQBrowser: ua.match(/MQQBrowser\/(\d+\.\d+)/i),
		UCBrowser: ua.match(/ucbrowser\/(\d+\.\d+)/i),
		Qzone: ua.match(/Qzone\/[\w\d\_]*(\d\.\d)[\.\w\d\_]*/i),
		Weibo: ua.match(/Weibo/i),
		qqnews: ua.match(/qqnews\/(\d+\.\d+\.\d+)/i),
		QQLiveBroadcast: ua.match(/QQLiveBroadcast/i),
		kuaibao: ua.match(/qnreading\/(\d+\.\d+\.\d+)/i),
		liebao: ua.match(/LieBaoFast\/(\d+\.\d+\.\d+)/i),
		IEMobile: ua.match(/IEMobile(\/|\s+)(\d+\.\d+)/) || ua.match(/WPDesktop/),
		douban: ua.match(/com\.douban\.frodo\/(\d+\.\d+\.\d+)/i),
		MiuiBrowser: ua.match(/MiuiBrowser\/(\d+\.\d+)/i),
		Chrome: os.ios ? ua.match(/CriOS\/(\d+\.\d+)/) : ua.match(/Chrome\/(\d+\.\d+)/),
		Safari: os.ios ? ua.match(/Safari\/(\d+\.\d+)/) : false,
		Firefox: ua.match(/Firefox\/(\d+\.\d+)/i),
		Line: ua.match(/Line/i),
		Facebook: ua.match(/FBAV/i) || ua.match(/FBAN/i),
		Instagram: ua.match(/Instagram/i),
		Twitter: ua.match(/Twitter/i), //这个不是100%准确的，好像就是没用的~~
		SamsungBrowser: ua.match(/SamsungBrowser/i),
		Submarine: ua.match(/Submarine/i)
	};

	if (browsercheck.MQQReader) {// 非主流的QQ阅读
		browser.MQQReader = true;
		browser.version = 1;
		browser.name = 'MQQReader';
	} else if (browsercheck.IEMobile) {
		browser.IEMobile = true;
		browser.version = 1;
		browser.name = 'IEMobile';
	} else {
		for (var i in browsercheck) {
			if (browsercheck[i]) {
				browser[i] = true;
				browser.version = browsercheck[i][1] || 0;
				browser.name = i;
				break;
			}
		}
	}

	return {
		browser: browser,
		os: os
	};
}
var cache = null;

var exportee = function () {
	return cache || (cache = check(navigator.userAgent));
};

//注入到express或者connect的中间件
exportee.__express = function (req, res, next) {
	req.ua = check(req.headers['user-agent']);
	next();
};
//注入到jquery或zepto
exportee.__jquery = function ($) {
	$ = $ || window.jQuery || window.Zepto;
	var res = cache || (cache = check(navigator.userAgent));
	$.browser = res.browser;
	$.os = res.os;
};

exportee.__clearCache = function () {
	cache = null;
};

module.exports = exportee;